<template>
  <div>
    <v-row>
      <v-col class="materia">{{mayus(materia.nombre)}}</v-col>
    </v-row>
    <v-row>
      <template v-for="(grupo, i) in materia.grupos">
        <v-col :key="i" xs3>
          <itemGrupo :grupo="grupo" class="border_nota" />
        </v-col>
      </template>
    </v-row>
  </div>
</template>

<script>
import API from "@/components/_config/conf";
import itemGrupo from "./itemGrupo";

export default {
  data() {
    return {};
  },
  components: {
    itemGrupo
  },
  props: ["materia"],
  mounted: function() {
    //console.log("mounted -> itemMateria", this.materia);
  },
  methods: {
    mayus(str) {
      let srt_result = API.ucFirst(str);
      return srt_result;
    }
  }
};
</script>

<style scoped>
.materia {
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #eee;
}

.border_nota {
  border-bottom: 1px solid #ccc;
}
</style>